module.exports = [
  {
    name: "Get Started",
    id: "get-started",
    resources: [
      {
        name: "What is Kudi?",
        id: "kudi",
        description:
          "<p>At Kudi, our mission is to make financial services accessible and affordable for all Africans. We believe that people of all classes should have access to financial services and seamlessly make transactions. We currently achieve this in partnership with our agent network. </p>",
      },
      {
        name: "How do I start using Kudi agent app?",
        id: "start-using-kudi",
        description:
          "<p>Becoming a Kudi Agent is very simple and fast! After you have downloaded the Kudi app, all you need to do is log in, fill in your personal details, phone number and bank details. You can then proceed to fund your wallet and start making transactions.</p>",
      },
      {
        name: "What can you do on the Kudi app?",
        id: "can-do-on-the-kudi-app",
        description:
          "<p>You can make the following transactions on the app;</p> <p>&nbsp; </p><ul></li><li>Transfer Money</li><li>Sell Airtime</li><li>TV Subscriptions</li><li>Pay Electricity Bills</li><li>Withdrawals and Cashout</li><li>Data subscriptions</li></ul>",
      },
      {
        name: "How do I become a Super Agent?",
        id: "super-agent",
        description:
          "<p>You have to be a Kudi agent first, and own a sizeable network of agents.</p>",
      },
      {
        name: "How can I know the working hours of Kudi?",
        id: "working-hours",
        description:
          "<p>Kindly be informed that our business hours are between<p> <ul><li> 8am - 8pm (Mondays - Saturday)</li><li>2pm - 6pm (Sundays)</li></ul>",
      },
      {
        name: "Can I call your Customer Representative or visit your office?",
        id: "call-customer-representative",
        description:
          "<p>At the moment, we provide customer support by calling our phone lines or through the help section on the app. Please send us a message via the app any time, and we will help you resolve whatever issue you may have.",
      },
    ],
  },
  {
    name: "Fees",
    id: "fees",
    resources: [
      {
        name: "How much do we charge for POS withdrawal?",
        id: "pos-withdrawal",
        description: `<p>Our transaction charge for POS withdrawals are:<p>  <br/>      
                    &nbsp; 100 - 4,500 (N25) <br/>
                    &nbsp;   4,501 - 25,000 (0.6%)  <br/>
                    &nbsp; 25,001 - 500,000 (N150) <br/>
      `,
      },
      {
        name: "Do I need to pay a fee to become an agent?",
        id: "become-an-agent",
        description: "<p>To become an agent is totally free.</p>",
      },
      {
        name: "Reporting Issues",
        id: "reporting-issues",
        description:
          '<p>Kindly find below customer support number and email </p><p> Number: <a href="tel:018885008">01 888 5008</a></p><br/><p>Email: <a href="mailto:support@kudi.co">support@kudi.co</a></p>',
      },
      {
        name: "How do I log issues to get a faster resolution?",
        id: "faster-resolution",
        description:
          "<p>To get your issues resolved faster, Kindly login to the Kudi APP, click <b>TRANSACTIONS</b>, click on the particular pending transaction, click <b>NEED HELP</b>, select the issue relating to your complaints, Add your comment, you can also upload image or take a picture, then <b>SUBMIT</b> and you will get updates till resolution is complete. </p>",
      },
      {
        name: "How can I access customer support numbers & Support Email?",
        id: "customer-support",
        description:
          '<p>Mail: <a href="mailto:support@kudi.co">support@kudi.co</a></p><p> Contact number: <a href="tel:018885008">01 888 5008</a></p><br/> ',
      },
    ],
  },
  {
    name: "Transactions & Wallet",
    id: "transactions-and-wallet",
    resources: [
      {
        name: "How do I fund my wallet?",
        id: "fund-wallet",
        description: `<p>
                    There are 2 ways to top up your wallet on Kudi;<br/>
                    &nbsp; - Make payments into your unique <a target="_blank" rel="noopener noreferrer" href="https://medium.com/agent-banking/how-to-use-the-kudi-top-up-account-kta-feature-14f514d136e"><strong>Kudi Top-up Account (KTA)</strong></a> using USSD, mobile bank transfer or over-the-counter bank transfer.<br/>
                    &nbsp; - Fund your wallet using your debit card.<br/>
                    <br/>
                    To fund your Kudi Top-up account, kindly follow these easy steps:<br/>
                    &nbsp; 1. Click on the “Fund wallet” on the Home page <br/>
                    &nbsp; 2. Enter amount <br/>
                    &nbsp; 3. Select “Bank Transfer” as your payment method <br/>
                    &nbsp; 4. Select the bank you will be funding from the bank list <br/>
                    &nbsp; 5. Dial the USSD string generated<br/>
                    &nbsp; 6. Select Providus Bank from your bank’s USSD response<br/>
                    &nbsp; 7. Enter your USSD Transaction PIN to complete the transaction<br/>
                    <br/>
                    To learn how to do an over-the-counter bank transfer into your KTA, click <a rel="noopener noreferrer" target="_blank" href="https://medium.com/agent-banking/completing-a-branch-inter-bank-transfers-with-kudi-top-up-account-kta-bffb073a891e"><strong>here</strong></a>.<br/><br/>
                    To fund your Kudi wallet using your card, kindly follow these easy steps;<br/>
                    &nbsp; 1. Click on the “Fund wallet” on the Home page <br/>
                    &nbsp; 2. Enter amount <br/>
                    &nbsp; 3. Select “Card Payment” as your payment method<br/>
                    &nbsp; 4. Click on “Add a new card<br/>
                    &nbsp; 5. Provide your card details and proceed to pay the amount inputted<br/>
                    &nbsp; 6. An OTP will be sent to your phone, enter this OTP and continue.<br/>
                    &nbsp; 7. You might be redirected to your bank verification service, follow the command as instructed by your bank. If successful, you will be directed back to Kudi and payment will be processed.<br/>
                    &nbsp; 8. Once processed, the transaction will be complete.<br/>
                </p>`,
      },
      {
        name: "Can I use the account number for payments?",
        id: "account-number-for-payments",
        description:
          "<p>No, your Kudi NUBAN is personal to you and only for receiving money into your Kudi Wallet.<br/> <b>Disclaimer</b>: Kudi will not be responsible for any fraudulent transaction performed with respect to this account number as you are solely responsible for the transactions recorded on this account.<p>",
      },
      {
        name: "How do I perform withdrawal transactions?",
        id: "perform-withdrawal-transactions",
        description: `<p>There are three ways to perform a withdrawal transaction; POS Withdrawal, Card Withdrawal (on the Kudi App) and USSD Withdrawal (also on your Kudi App).<p>
          <p>To perform a withdrawal transaction with a POS, follow these easy steps:</p>
         <p> From the main menu</p>
          <ul>
          <li> 	&#8226; &nbsp; Select 1 for Cash out</li>
          <li> 	&#8226; &nbsp; Input the Amount and press the “ENTER” button</li>
          <li> 	&#8226; &nbsp; Insert Debit Card</li>
          <li> 	&#8226; &nbsp; 
          Inform the Customer to Input their PIN</li>
          </ul>
          <p>The Transaction will be processed and a receipt will be printed. </p>

          <p>To perform a withdrawal from the App, kindly click on “Withdraw Money” and select your preferred withdrawal method.</p>

          <p>To use the Card Withdrawal option, kindly follow these easy steps:</p>
          <ul>
          <li> 	&#8226; &nbsp; Click on Withdraw money on the homepage and select “Card Payment”</li>
          <li> 	&#8226; &nbsp; Enter Amount</li>
          <li> 	&#8226; &nbsp; Enter your Kudi PIN</li>
          <li> 	&#8226; &nbsp; Enter the Card Details and proceed to pay the amount inputted</li>
          <li> 	&#8226; &nbsp; An OTP will be sent to the customer’s phone, enter this OTP and continue</li>
          <li> 	&#8226; &nbsp; You might be redirected to the Bank verification service, follow the command as instructed by the Bank. If successful, you will be directed back to Kudi and payment will be processed.
          </li>
          </ul>

          <p>To use the USSD Withdrawal option, kindly follow these easy steps:</p>

          <ul>
          <li> 	&#8226; &nbsp; Click on Withdraw money on the homepage, select USSD Withdrawal</li>
          <li> 	&#8226; &nbsp; Select Provider (Customer’s bank)</li>
          <li> 	&#8226; &nbsp; Enter Customer’s Phone Number (phone number registered to their bank)</li>
          <li> 	&#8226; &nbsp; Enter Amount</li>
          <li> 	&#8226; &nbsp; 
          Inform the customer to dial the USSD code generated on their registered phone number to complete the transaction</li>
          <li> 	&#8226; &nbsp; Once the transaction is successfully processed your wallet will be credited.</li>

          </ul>
          `,
      },
      {
        name: "Do you offer free POS terminals?",
        id: "free-pos",
        description:
          "<p>Yes, we do, but it is based on the number of transactions you do on the app.</p><p> We also give it out on first come, first served basis.</p> <p>You can now request to buy a POS from the APP after updating it.</p>",
      },
      {
        name:
          "How can I resolve approved withdrawals not reconciled to my wallet?",
        id: "withdrawals-not-reconciled",
        description: `<ul>
          <li> 	&#8226; &nbsp;  Click on the Support Icon
          </li>
          <li> 	&#8226; &nbsp;  Select “Cash Withdrawal”</li>
          <li> 	&#8226; &nbsp;  Click on “My wallet hasn’t been credited for a successful POS transaction”</li>
          <li> 	&#8226; &nbsp;  Fill the details and ensure you input the RRN</li>
          <li> 	&#8226; &nbsp;  Click on “Submit Issue” </li>
          </ul> <br/>
          <p>
          Once you click submit, the issue has been logged and resolution takes 72 working hours.
          </p>`,
      },
      {
        name: "How do I perform withdrawal on the App?",
        id: "perform-withdrawal",
        description: `<p>
                    Kindly click on withdraw money and follow the prompts.<br/>
                    &#8226; &nbsp; On the choose payment method, <br/> 
                    &#8226; &nbsp; Kindly click on DEBIT CARD, <br/>
                    &#8226; &nbsp; The customer will receive an OTP to complete the transaction.
                </p>`,
      },
      {
        name: "How do I transfer on the App?",
        id: "transfer-on-the-App",
        description: `<p>To perform a transfer transaction on the App, kindly follow these easy steps:</p> <br/>

        &nbsp; 	&#8226; Select “Transfer Money” on the homepage <br/>
        &nbsp; 	&#8226; Enter the recipient’s account number and select the Bank <br/>
        &nbsp; 	&#8226; Enter Amount <br/>
        &nbsp; 	&#8226; Enter Sender’s information <br/>
        &nbsp; 	&#8226; Verify information and input your Kudi pin to Authorize the transaction<br/>
        <p>Once completed the recipient will receive value immediately. We charge a flat fee of N20 per transaction</p>
                    `,
      },
      {
        name: "What do I do if I have a Chargeback situation?",
        id: "chargeback",
        description: `
        <ul>
          <li> &nbsp;	&#8226; Click on ‘Transactions”</li>
          <li> &nbsp;	&#8226; Select the failed transaction</li>
          <li> &nbsp;	&#8226; Click on “Need help”</li>
          <li> &nbsp;	&#8226; Select  “My customer’s card was debited for a declined/failed POS transaction”</li>
          <li> &nbsp;	&#8226; Click on “Submit Issue”</li>
        </ul>
        <p>
        Once you click submit, the issue has been logged and resolution takes 72 working hours  </p>`,
      },
      {
        name: "How do I resolve Dstv, Gotv, Startimes issues?",
        id: "bouquet-issues",
        description:
          "<p>Kindly contact support with the decoder number to confirm the status of the transaction.</p>",
      },
      {
        name: "How do I get my token after paying for PHCN?",
        id: "electricity-bills",
        description:
          "<p>For prepaid PHCN, the meter token is on the transaction receipt on the APP, once it is inputted, the value will be received immediately and if the customer still claims not to get value, please send the screenshot to support for prompt resolution.</p>",
      },
    ],
  },
  {
    name: "Terminals (POS)",
    id: "terminals",
    resources: [
      {
        name: " What is Terminal ID?",
        id: "terminal-id",
        description:
          "<p>A unique identification number that is allocated to a POS terminal and can be found on the merchant copy receipt of a POS transaction.</p>",
      },
      {
        name: "Do you offer free POS terminals?",
        id: "pos-terminals",
        description:
          "<p>Yes, the POS terminals are free. However, you will be required to pay a security deposit/caution fee of N20,000 and also provide end-of-day transaction report or statement of account to prove that you can meet the transaction target on the POS terminal.</p>",
      },
      {
        name: "How do I get my POS mapped?",
        id: "pos-mapped",
        description:
          "<p>Once you receive your POS terminal, please confirm if it has been mapped by a Kudi Field Representative who deployed the POS to you, If it has not been mapped, the Kudi Representative will do that ASAP! </p>",
      },
      {
        name: "How do I know if my POS is mapped?",
        id: "is-pos-mapped",
        description:
          "<p>You will get feedback from  Customer Support asking you to do a test transaction.  Once you get an alert after a successful test, then your terminal is ready for transactions.</p>",
      },
      {
        name: "What do I do if my POS is showing Routing Error?",
        id: "routing-error",
        description:
          "<p>If your POS is showing routing error, kindly send your terminal ID and wallet to Customer Support for an onward resolution.</p>",
      },
      {
        name: "How do I know my terminal Manufacturer?",
        id: "terminal-manufacturer",
        description:
          "<p>Kindly check the body of the terminal close to the screen for the POS manufacturer.</p>",
      },
      {
        name: "How can I print my End OF DAY Transactions on my POS?",
        id: "end-of-day-transactions",
        description: `<p>
                    How to print end of day(EOD) on NEXGO G2 terminal<br/><br/>
                    *Select 8 for reprint<br/>
                    *Password: 000000<br/>
                    *Then select 2 for PRINT EODs<br/>
                    *Then select 2 for EOD BY DATE<br/>
                    *Then input the month and date in this format (MM/DD) Example: 0415 then press enter"<br/><br/>
                    How to print end of day(EOD) on PAX S90 terminal<br/><br/>
                    *Select 2 for End of Day<br/>
                    *Supervisor Password: 12345<br/>
                    *Then select 2 for EOD BY DATE
                </p>`,
      },
      {
        name: "POS issues and resolution ",
        id: "pos-issues-resolution",
        description: `
                    <p><strong>Routing Error</strong></p>
                    <p>Terminal has not been configured with correct routing group, ISW or NIBSS did not process the transaction. We will need to send the Terminal ID to the Bank for reactivation (This might take up to 48 hours).</p><br/>
                    <p><strong>Warning App Exception</strong></p>
                    <p>This may occur due to poor network reception at agent location.Kindly change the  SIM (Network) on the POS .</p> <br/>
                    <p><strong>Empty Response</strong></p>
                    <p>This may occur due to an error in network communication or the service provider of the POS terminal is down.<br/>
                        "Kindly initiate a key exchange on the POS terminal with this process:<br/>      
                        * On the home screen press "Enter button"<br/>
                        * Select admin and input password (000000) <br/>
                        *Press 1(Log on)<br/>
                        *Press 1 (Trans log on)<br/>
                        *User ID (01)<br/>
                        *Password (0000)<br/>
                        *Watch it download all keys and setups till it shows (LOG ON SUCCESS)
                    </p>
            `,
      },
      {
        name: "POS shows: MENU LOCK, BROWSE, ADVANCE, TEST",
        id: "pos-shows",
        description: `
                <p>This may occur due to mishandling or usage of bad debit cards on the POS terminal. The terminal needs to be retrieved for physical repair, Kindly contact the Kudi official who deployed the POS to you. </p><br/>
                <p><strong>Pos Tampered! Please input PWD</strong></p>
                <p>This may occur due to mishandling of the POS TERMINAL. The terminal needs to be retrieved for a physical repair, Kindly contact the <strong>Kudi official</strong> who deployed the POS to you.</p><br/>
                <p><strong>Issuer or Switch Inoperative</strong></p>
                <p>This error could be coming from the card issuer’s bank host or the switch (NIBSS or ISW) is unavailable. Please tell the card holder to contact the card issuer.</p><br/>
                <p><strong>Function not supported</strong></p>
                <p>Terminal has not been configured with correct routing group ISW or NIBSS did not process transaction, Kindly contact support, Resolution may take <strong>72 hours.</strong></p><br/>
                <p><strong>Error Unpacking</strong></p>
                <p>Turn on your terminal, while booting when it shows preparing network, hold down the function button and press the clear button twice  (clear button is under zero). Immediately while holding down the function button a message will pop up requesting for admin password,<br/>
*Please type - 145522, <br/>
*Press enter, scroll down till you find delete keys.  <br/>
*Press 3 for delete keys, if it prompts, Kindly reboot the terminal.<br/>
You will be prompted to reboot the app again, after rebooting try a transaction.</p>
`,
      },
    ],
  },

  {
    name: "Marketing Resources",
    id: "marketing-resources",
    resources: [
      {
        name: "How do I get branded materials for my shop?",
        id: "marketing",
        description:
          "<p>To get Kudi branded materials, make a request through our support channels or contact the Kudi representative in your state.</p>",
      },
    ],
  },
  {
    name: "Security & Privacy",
    id: "security-&-privacy",
    resources: [
      {
        name: "How do I change my password?",
        id: "change-password",
        description:
          "<p>Kindly click on the APP, please click sign in with another user, click forgot password, input the desired password and an OTP will be sent to you for password change completion. You can then login with the new password.</p>",
      },
      {
        name: "How do you handle my personal information?",
        id: "personal-information",
        description:
          "<p>We will never sell, rent, or loan any personal information that you give us.</p>",
      },
      {
        name: "Why must my location be visible to complete a transaction?",
        id: "location-visible",
        description:
          "<p>We request that your location information is visible to complete a transaction in order to protect you against a fraudulent transaction. In the case of fraud or theft of a device, the location in which the transaction was initiated serves as a guide in tracking the culprit.</p>",
      },
      {
        name: "Why is my phone IMEI needed?",
        id: "phone-IMEI",
        description:
          "<p>We request your phone IMEI to protect against possible fraudulent transactions on multiple accounts from a single device.</p>",
      },
      {
        name: "Why is BVN information needed?",
        id: "BVN-info",
        description:
          "<p>As a method of detecting fraudulent accounts, we request your BVN details - your First name, Last name, Phone number, Date of Birth and Face ID. Please note, Kudi does not have access to your account information. The BVN verification process only confirms that your personal details provided on Kudi are the same as it is in your BVN.</p>",
      },
    ],
  },
  {
    name: "App Download / Update",
    id: "app-download-update",
    resources: [
      {
        name: "How do I update my App?",
        id: "update-app",
        description:
          "<p>Visit the Applications manager on your Android phone and look for the Kudi app, you can click update for the latest version. If you don't see the update button, then your Kudi app is up to date.</p>",
      },
    ],
  },
]
